var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 8.44772 0.447715 8 1 8H23C23.5523 8 24 8.44772 24 9C24 9.55228 23.5523 10 23 10H1C0.447715 10 0 9.55228 0 9Z",
    fill: "#0D0E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.5523 0 13 0.447715 13 1V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V1C11 0.447715 11.4477 0 12 0Z",
    fill: "#0D0E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C6.55228 0 7 0.447715 7 1V5C7 5.55228 6.55228 6 6 6C5.44772 6 5 5.55228 5 5V1C5 0.447715 5.44772 0 6 0Z",
    fill: "#0D0E0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C18.5523 0 19 0.447715 19 1V5C19 5.55228 18.5523 6 18 6C17.4477 6 17 5.55228 17 5V1C17 0.447715 17.4477 0 18 0Z",
    fill: "#0D0E0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C2.89543 4 2 4.89543 2 6V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V6C22 4.89543 21.1046 4 20 4H4ZM0 6C0 3.79086 1.79086 2 4 2H20C22.2091 2 24 3.79086 24 6V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V6Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2168 19.4779C10.3818 19.5731 10.6107 19.4853 10.5155 19.6503L10.1706 20.2475C10.0754 20.4124 9.86455 20.4689 9.69963 20.3737C9.53471 20.2785 9.47821 20.0676 9.57343 19.9027L9.91823 19.3055C10.0134 19.1405 10.0519 19.3826 10.2168 19.4779Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6429 12.5174C12.9285 12.0226 13.5612 11.8531 14.0559 12.1388L14.6531 12.4836C15.1479 12.7692 15.3174 13.4019 15.0318 13.8966L14.6869 14.4939L12.2981 13.1146L12.6429 12.5174ZM11.9532 13.7119L9.53962 17.8924C9.5149 17.9352 9.49968 17.9828 9.49499 18.032C9.45041 18.4992 9.43804 18.8919 9.47961 19.1974C9.51945 19.4902 9.622 19.7999 9.90107 19.962C10.1771 20.1224 10.4984 20.0636 10.7782 19.9588C11.0714 19.8489 11.4183 19.6508 11.8192 19.3874C11.8642 19.3578 11.9016 19.3182 11.9285 19.2716L14.3421 15.0911L11.9532 13.7119Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group6.48d1cdd8b69f8abf6c04f06f5d5817cf.svg";
export { ForwardRef as ReactComponent };